import { ViewEventoInsegnamento } from "@/components/ViewEventoInsegnamento/ViewEventoInsegnamento";
import { Card, List, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { APP_DATE_FORMAT } from "@/config/constants";
import { useAppSelector } from "@/config/store";
import { IEdoCourseEvent } from "@/shared/model/edo-course-event.model";
import { IEdoCourse } from "@/shared/model/edo-course.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { Calendar } from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { TextFormat, Translate } from "react-jhipster";

export interface BoxEventiInsegnamentoProps {
  insegnamento: IEdoCourse;
}

export const BoxEventiInsegnamento = (props: BoxEventiInsegnamentoProps) => {
  const [courseEvents, setCourseEvents] = useState<IEdoCourseEvent[]>([]);
  const { updateSuccess } = useAppSelector<EntityState<IEdoCourseEvent>>(
    (state) => state.edoCourseEvent
  );
  const [viewEvento, setViewEvento] = useState<boolean>(false);
  const [eventoToView, setEventoToView] = useState<IEdoCourseEvent | null>(null);
  const { insegnamento } = props;

  const openViewEvento = (evento: IEdoCourseEvent) => {
    setViewEvento(true);
    setEventoToView(evento);
  };

  useEffect(() => {
    const getCourseEvents = async () => {
      const response = await axios.get("/course-events", {
        params: {
          page: 0,
          size: 5,
          sortBy: "startDate:DESC",
          "filter.course.id": "$eq:" + String(insegnamento.id),
        },
      });
      setCourseEvents(response.data.data);
    };
    if (insegnamento?.id) getCourseEvents();
  }, [insegnamento?.id, updateSuccess]);

  return (
    <>
      <Card className="surface overflow-hidden p-0">
        <div className="border-b border-[var(--color-mockup-border)] px-4 py-3">
          <h3 className="font-heading text-base font-bold text-[var(--color-mockup-text)]">
            Eventi
          </h3>
        </div>
        <List>
          {courseEvents.length ? (
            courseEvents.map((evento) => (
              <ListItem
                key={evento.id}
                className="flex cursor-pointer items-center gap-3 transition-colors hover:bg-primary/5"
                onClick={() => openViewEvento(evento)}
              >
                <ListItemIcon className="mr-0 shrink-0">
                  <Calendar className="h-5 w-5 text-[var(--color-mockup-text-light)]" />
                </ListItemIcon>
                <ListItemText
                  primary={evento.title}
                  secondary={
                    <TextFormat
                      value={evento.startDate}
                      type="date"
                      format={APP_DATE_FORMAT}
                    />
                  }
                />
              </ListItem>
            ))
          ) : (
            <li className="px-4 py-4 text-center text-body-sm text-[var(--color-mockup-text-light)]">
              <Translate contentKey="edocendoApp.edoCourseEvent.home.notFound">
                No Edo Evento Insegnamentos found
              </Translate>
            </li>
          )}
        </List>
      </Card>
      <ViewEventoInsegnamento
        open={viewEvento}
        handleClose={() => setViewEvento(false)}
        eventId={eventoToView?.id}
      />
    </>
  );
};

export default BoxEventiInsegnamento;
